import { render, staticRenderFns } from "./GridDetailBtn.vue?vue&type=template&id=ba145c0c"
import script from "./GridDetailBtn.vue?vue&type=script&lang=js"
export * from "./GridDetailBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports